import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule, inject, Injectable } from '@angular/core';
import { tuiRgbToHex, tuiHexToRgb, tuiRgbToHsv, tuiHsvToRgb, tuiParseGradient, tuiGetGradientData, tuiParseColor } from '@taiga-ui/cdk/utils/color';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i3 from '@maskito/angular';
import { MaskitoDirective } from '@maskito/angular';
import * as i4 from '@taiga-ui/legacy/components/primitive-textfield';
import { TuiPrimitiveTextfieldModule } from '@taiga-ui/legacy/components/primitive-textfield';
import * as i5 from '@taiga-ui/legacy/directives/textfield-controller';
import { TuiTextfieldControllerModule } from '@taiga-ui/legacy/directives/textfield-controller';
import * as i6 from '@taiga-ui/legacy/components/input-number';
import { TuiInputNumberModule } from '@taiga-ui/legacy/components/input-number';
import * as i7 from '@taiga-ui/legacy/components/select';
import { TuiSelectModule } from '@taiga-ui/legacy/components/select';
import * as i1$1 from '@taiga-ui/core/directives/dropdown';
import { TuiDropdown } from '@taiga-ui/core/directives/dropdown';
import * as i2$1 from '@taiga-ui/core/components/data-list';
import { TuiDataList } from '@taiga-ui/core/components/data-list';
import * as i2$2 from '@taiga-ui/core/components/button';
import { TuiButton } from '@taiga-ui/core/components/button';
import { __decorate } from 'tslib';
import { DomSanitizer } from '@angular/platform-browser';
import { tuiRound } from '@taiga-ui/cdk/utils/math';
import { tuiPure, tuiCreateToken, tuiProvideOptions, tuiDefaultSort } from '@taiga-ui/cdk/utils/miscellaneous';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tuiTypedFromEvent, tuiPreventDefault } from '@taiga-ui/cdk/observables';
import { tuiInjectElement, tuiGetElementPoint } from '@taiga-ui/cdk/utils/dom';
import { Observable, switchMap, map, takeUntil, startWith } from 'rxjs';
import * as i8 from '@taiga-ui/core/directives/group';
import { TuiGroup } from '@taiga-ui/core/directives/group';
import * as i1$2 from '@taiga-ui/core/directives/hint';
import { TuiHint } from '@taiga-ui/core/directives/hint';
import * as i11 from '@taiga-ui/kit/directives/chevron';
import { TuiChevron } from '@taiga-ui/kit/directives/chevron';
import * as i12 from '@taiga-ui/core/components/icon';
import { TuiIcon } from '@taiga-ui/core/components/icon';
import { TuiActiveZone } from '@taiga-ui/cdk/directives/active-zone';
import { TuiSvgComponent } from '@taiga-ui/legacy/components/svg';
const _c0 = () => ({
  standalone: true
});
function TuiColorEditComponent_tui_data_list_1_button_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r2, " ");
  }
}
function TuiColorEditComponent_tui_data_list_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tui-data-list", 5);
    i0.ɵɵtemplate(1, TuiColorEditComponent_tui_data_list_1_button_1_Template, 2, 2, "button", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.modes);
  }
}
function TuiColorEditComponent_tui_primitive_textfield_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-primitive-textfield", 8);
    i0.ɵɵlistener("valueChange", function TuiColorEditComponent_tui_primitive_textfield_2_Template_tui_primitive_textfield_valueChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onHexChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("maskito", ctx_r2.hexMask)("tuiTextfieldLabelOutside", true)("value", ctx_r2.hex);
  }
}
function TuiColorEditComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-input-number", 9);
    i0.ɵɵlistener("ngModelChange", function TuiColorEditComponent_ng_template_3_Template_tui_input_number_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRgbChange($event, ctx_r2.color[1], ctx_r2.color[2], ctx_r2.color[3]));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(1, "tui-input-number", 9);
    i0.ɵɵlistener("ngModelChange", function TuiColorEditComponent_ng_template_3_Template_tui_input_number_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRgbChange(ctx_r2.color[0], $event, ctx_r2.color[2], ctx_r2.color[3]));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "tui-input-number", 9);
    i0.ɵɵlistener("ngModelChange", function TuiColorEditComponent_ng_template_3_Template_tui_input_number_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onRgbChange(ctx_r2.color[0], ctx_r2.color[1], $event, ctx_r2.color[3]));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("max", 255)("min", 0)("ngModel", ctx_r2.color[0])("ngModelOptions", i0.ɵɵpureFunction0(15, _c0))("tuiTextfieldLabelOutside", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("max", 255)("min", 0)("ngModel", ctx_r2.color[1])("ngModelOptions", i0.ɵɵpureFunction0(16, _c0))("tuiTextfieldLabelOutside", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("max", 255)("min", 0)("ngModel", ctx_r2.color[2])("ngModelOptions", i0.ɵɵpureFunction0(17, _c0))("tuiTextfieldLabelOutside", true);
  }
}
function TuiLinearMultiPickerComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("dblclick", function TuiLinearMultiPickerComponent_div_0_Template_div_dblclick_0_listener() {
      const index_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onClick(index_r2));
    })("mousedown", function TuiLinearMultiPickerComponent_div_0_Template_div_mousedown_0_listener() {
      const index_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMouseDown(index_r2));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵstyleProp("left", item_r4 * 100, "%");
  }
}
const _c1 = "[_nghost-%COMP%]{position:relative;display:block;block-size:1rem;box-sizing:border-box}.t-circle[_ngcontent-%COMP%]{position:absolute;inline-size:1rem;block-size:1rem;border-radius:100%;outline:1px solid var(--tui-background-base);margin:0 -.5rem;box-shadow:inset 0 0 0 2px var(--tui-base-01),0 0 0 1px var(--tui-base-03)}";
function TuiPaletteComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function TuiPaletteComponent_button_0_Template_button_click_0_listener() {
      const color_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectedColor.emit(color_r2.value));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const color_r2 = ctx.$implicit;
    i0.ɵɵstyleProp("background", color_r2.value);
    i0.ɵɵproperty("id", color_r2.key)("tuiHint", color_r2.key)("tuiHintDescribe", color_r2.key);
  }
}
function TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_tui_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-icon", 12);
  }
}
function TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_Template_button_click_0_listener() {
      const mode_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onModeSelect(mode_r4));
    })("keydown.enter.prevent", function TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_Template_button_keydown_enter_prevent_0_listener() {
      const mode_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onModeSelect(mode_r4));
    })("keydown.space.prevent", function TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_Template_button_keydown_space_prevent_0_listener() {
      const mode_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onModeSelect(mode_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_tui_icon_2_Template, 1, 0, "tui-icon", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const mode_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-checked", ctx_r1.isModeActive(mode_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", mode_r4, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isModeActive(mode_r4));
  }
}
function TuiColorSelectorComponent_ng_container_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tui-data-list", 8);
    i0.ɵɵtemplate(1, TuiColorSelectorComponent_ng_container_0_ng_template_4_button_1_Template, 3, 3, "button", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.modes);
  }
}
function TuiColorSelectorComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵtwoWayListener("tuiDropdownOpenChange", function TuiColorSelectorComponent_ng_container_0_Template_div_tuiDropdownOpenChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.open, $event) || (ctx_r1.open = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TuiColorSelectorComponent_ng_container_0_ng_template_4_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "hr", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const menu_r5 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tuiDropdown", menu_r5);
    i0.ɵɵtwoWayProperty("tuiDropdownOpen", ctx_r1.open);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentMode, " ");
  }
}
function TuiColorSelectorComponent_ng_container_1_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵlistener("click", function TuiColorSelectorComponent_ng_container_1_button_4_Template_button_click_0_listener() {
      const button_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDirectionChange(button_r8));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("t-direction_active", ctx_r1.isDirectionActive(button_r8));
    i0.ɵɵproperty("iconStart", ctx_r1.getIcon(button_r8))("tuiHint", button_r8);
  }
}
function TuiColorSelectorComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 13)(2, "tui-linear-multi-picker", 14);
    i0.ɵɵlistener("indexChange", function TuiColorSelectorComponent_ng_container_1_Template_tui_linear_multi_picker_indexChange_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onIndexChange($event));
    })("valueChange", function TuiColorSelectorComponent_ng_container_1_Template_tui_linear_multi_picker_valueChange_2_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onStopsChange($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 15);
    i0.ɵɵtemplate(4, TuiColorSelectorComponent_ng_container_1_button_4_Template, 1, 4, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("background", ctx_r1.gradient);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", ctx_r1.stopsKeys);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.buttons);
  }
}
function TuiColorSelectorComponent_tui_color_edit_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-color-edit", 18);
    i0.ɵɵlistener("colorChange", function TuiColorSelectorComponent_tui_color_edit_3_Template_tui_color_edit_colorChange_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onColorChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("color", ctx_r1.color);
  }
}
function TuiColorSelectorComponent_tui_palette_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tui-palette", 19);
    i0.ɵɵlistener("selectedColor", function TuiColorSelectorComponent_tui_palette_4_Template_tui_palette_selectedColor_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPalettePick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("colors", ctx_r1.palette);
  }
}
const HEX_MODE_LENGTH = 6;
let TuiColorEditComponent = /*#__PURE__*/(() => {
  class TuiColorEditComponent {
    constructor() {
      this.color = [0, 0, 0, 1];
      this.colorChange = new EventEmitter();
      this.hexMask = {
        mask: new RegExp(`^[A-F\\d]{0,${HEX_MODE_LENGTH}}$`, 'gi')
      };
      this.modes = ['HEX', 'RGB'];
      this.mode = this.modes[0];
    }
    get isHex() {
      return this.mode === this.modes[0];
    }
    get hex() {
      return tuiRgbToHex(this.color[0], this.color[1], this.color[2]).replace('#', '');
    }
    get opacity() {
      return Math.round(this.color[3] * 100);
    }
    onHexChange(hex) {
      if (hex.length !== HEX_MODE_LENGTH) {
        return;
      }
      const rgb = tuiHexToRgb(hex);
      this.updateColor([rgb[0], rgb[1], rgb[2], this.color[3]]);
    }
    onRgbChange(...rgba) {
      this.updateColor(rgba);
    }
    updateColor(color) {
      this.color = color;
      this.colorChange.emit(color);
    }
    static {
      this.ɵfac = function TuiColorEditComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorEditComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiColorEditComponent,
        selectors: [["tui-color-edit"]],
        inputs: {
          color: "color"
        },
        outputs: {
          colorChange: "colorChange"
        },
        standalone: false,
        decls: 6,
        vars: 16,
        consts: [["rgb", ""], ["tuiDropdownAlign", "left", "tuiDropdownLimitWidth", "min", "tuiTextfieldSize", "m", 1, "t-select", 3, "ngModelChange", "ngModelOptions", "tuiTextfieldLabelOutside", "ngModel"], ["size", "s", 4, "tuiDataList"], ["tuiTextfieldSize", "m", 3, "maskito", "tuiTextfieldLabelOutside", "value", "valueChange", 4, "ngIf", "ngIfElse"], ["tuiTextfieldPostfix", "%", "tuiTextfieldSize", "m", 1, "t-opacity", 3, "ngModelChange", "max", "min", "ngModel", "ngModelOptions", "tuiTextfieldLabelOutside"], ["size", "s"], ["tuiOption", "", "type", "button", 3, "value", 4, "ngFor", "ngForOf"], ["tuiOption", "", "type", "button", 3, "value"], ["tuiTextfieldSize", "m", 3, "valueChange", "maskito", "tuiTextfieldLabelOutside", "value"], ["tuiTextfieldSize", "m", 1, "t-rgb", 3, "ngModelChange", "max", "min", "ngModel", "ngModelOptions", "tuiTextfieldLabelOutside"]],
        template: function TuiColorEditComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "tui-select", 1);
            i0.ɵɵtwoWayListener("ngModelChange", function TuiColorEditComponent_Template_tui_select_ngModelChange_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.mode, $event) || (ctx.mode = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵtemplate(1, TuiColorEditComponent_tui_data_list_1_Template, 2, 1, "tui-data-list", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, TuiColorEditComponent_tui_primitive_textfield_2_Template, 1, 3, "tui-primitive-textfield", 3)(3, TuiColorEditComponent_ng_template_3_Template, 3, 18, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(5, "tui-input-number", 4);
            i0.ɵɵlistener("ngModelChange", function TuiColorEditComponent_Template_tui_input_number_ngModelChange_5_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onRgbChange(ctx.color[0], ctx.color[1], ctx.color[2], $event / 100));
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const rgb_r6 = i0.ɵɵreference(4);
            i0.ɵɵstyleProp("flex", "0 0 auto");
            i0.ɵɵproperty("ngModelOptions", i0.ɵɵpureFunction0(14, _c0))("tuiTextfieldLabelOutside", true);
            i0.ɵɵtwoWayProperty("ngModel", ctx.mode);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isHex)("ngIfElse", rgb_r6);
            i0.ɵɵadvance(3);
            i0.ɵɵstyleProp("flex", "0 0 auto");
            i0.ɵɵproperty("max", 100)("min", 0)("ngModel", ctx.opacity)("ngModelOptions", i0.ɵɵpureFunction0(15, _c0))("tuiTextfieldLabelOutside", true);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2.NgControlStatus, i2.NgModel, i3.MaskitoDirective, i4.TuiPrimitiveTextfieldComponent, i4.TuiPrimitiveTextfieldDirective, i5.TuiTextfieldLabelOutsideDirective, i5.TuiTextfieldSizeDirective, i5.TuiTextfieldPostfixDirective, i6.TuiInputNumberComponent, i6.TuiInputNumberDirective, i7.TuiSelectComponent, i7.TuiSelectDirective, i1$1.TuiDropdownOptionsDirective, i2$1.TuiDataListComponent, i2$1.TuiDataListDirective, i2$1.TuiOption],
        styles: ["[_nghost-%COMP%]{display:flex}.t-select[_ngcontent-%COMP%]{inline-size:5.875rem}.t-opacity[_ngcontent-%COMP%]{inline-size:4.275rem}.t-rgb[_ngcontent-%COMP%], .t-opacity[_ngcontent-%COMP%]{text-align:center}"],
        changeDetection: 0
      });
    }
  }
  return TuiColorEditComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiColorEditModule = /*#__PURE__*/(() => {
  class TuiColorEditModule {
    static {
      this.ɵfac = function TuiColorEditModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorEditModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiColorEditModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, TuiPrimitiveTextfieldModule, TuiTextfieldControllerModule, TuiInputNumberModule, TuiSelectModule, i1$1.TuiDropdownComponent, i2$1.TuiDataListComponent, i2$1.TuiOption]
      });
    }
  }
  return TuiColorEditModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPickerService = /*#__PURE__*/(() => {
  class TuiPickerService extends Observable {
    constructor() {
      super(subscriber => this.point$.subscribe(subscriber));
      this.el = tuiInjectElement();
      this.doc = inject(DOCUMENT);
      this.point$ = tuiTypedFromEvent(this.el, 'mousedown').pipe(tuiPreventDefault(), switchMap(event => {
        const mouseMove$ = tuiTypedFromEvent(this.doc, 'mousemove').pipe(map(({
          clientX,
          clientY
        }) => tuiGetElementPoint(clientX, clientY, this.el)), takeUntil(tuiTypedFromEvent(this.doc, 'mouseup')));
        return event.target === this.el ? mouseMove$.pipe(startWith(tuiGetElementPoint(event.clientX, event.clientY, this.el))) : mouseMove$;
      }), takeUntilDestroyed());
    }
    static {
      this.ɵfac = function TuiPickerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPickerService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TuiPickerService,
        factory: TuiPickerService.ɵfac
      });
    }
  }
  return TuiPickerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiFlatPickerComponent = /*#__PURE__*/(() => {
  class TuiFlatPickerComponent {
    constructor() {
      this.$ = inject(TuiPickerService).pipe(takeUntilDestroyed()).subscribe(point => {
        this.value = point;
        this.valueChange.emit([point[0], point[1]]);
      });
      this.value = [0, 0];
      this.valueChange = new EventEmitter();
    }
    get left() {
      return this.value[0] * 100;
    }
    get top() {
      return this.value[1] * 100;
    }
    static {
      this.ɵfac = function TuiFlatPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFlatPickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiFlatPickerComponent,
        selectors: [["tui-flat-picker"]],
        inputs: {
          value: "value"
        },
        outputs: {
          valueChange: "valueChange"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([TuiPickerService])],
        decls: 1,
        vars: 4,
        consts: [[1, "t-circle"]],
        template: function TuiFlatPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("left", ctx.left, "%")("top", ctx.top, "%");
          }
        },
        styles: ["[_nghost-%COMP%]{position:relative;display:block}.t-circle[_ngcontent-%COMP%]{position:absolute;inline-size:1rem;block-size:1rem;border-radius:100%;outline:1px solid var(--tui-background-base);margin:-.5rem 0 0 -.5rem;box-shadow:inset 0 0 0 1px var(--tui-base-01),0 0 0 1px var(--tui-base-03)}"],
        changeDetection: 0
      });
    }
  }
  return TuiFlatPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiLinearPickerComponent = /*#__PURE__*/(() => {
  class TuiLinearPickerComponent {
    constructor() {
      this.$ = inject(TuiPickerService).pipe(takeUntilDestroyed()).subscribe(([x]) => {
        this.value = x;
        this.valueChange.emit(x);
      });
      this.value = 0;
      this.valueChange = new EventEmitter();
    }
    get left() {
      return this.value * 100;
    }
    static {
      this.ɵfac = function TuiLinearPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiLinearPickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiLinearPickerComponent,
        selectors: [["tui-linear-picker"]],
        inputs: {
          value: "value"
        },
        outputs: {
          valueChange: "valueChange"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([TuiPickerService])],
        decls: 1,
        vars: 2,
        consts: [[1, "t-circle"]],
        template: function TuiLinearPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("left", ctx.left, "%");
          }
        },
        styles: ["[_nghost-%COMP%]{position:relative;display:block;block-size:1rem;box-sizing:border-box}.t-circle[_ngcontent-%COMP%]{position:absolute;inline-size:1rem;block-size:1rem;border-radius:100%;outline:1px solid var(--tui-background-base);margin:0 -.5rem;box-shadow:inset 0 0 0 2px var(--tui-base-01),0 0 0 1px var(--tui-base-03)}"],
        changeDetection: 0
      });
    }
  }
  return TuiLinearPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiColorPickerComponent = /*#__PURE__*/(() => {
  class TuiColorPickerComponent {
    constructor() {
      this.sanitizer = inject(DomSanitizer);
      this.point = [0, 1];
      this.hue = 0;
      this.opacity = 1;
      this.colorChange = new EventEmitter();
    }
    set color(color) {
      if (this.currentColor.every((item, index) => item === color[index]) && color[3] === this.opacity) {
        return;
      }
      const [h, s, v] = tuiRgbToHsv(color[0], color[1], color[2]);
      this.opacity = color[3];
      this.hue = h / 360;
      this.point = [s, 1 - v / 255];
    }
    get currentColor() {
      return this.getCurrentColor(this.hue, this.point);
    }
    get base() {
      return `rgb(${tuiHsvToRgb(this.hue * 360, 1, 255)})`;
    }
    get gradient() {
      return this.sanitizer.bypassSecurityTrustStyle(`linear-gradient(to right, rgba(${this.currentColor.join(',')}, 0), rgb(${this.currentColor.join(',')}))`);
    }
    onPointChange(point) {
      this.point = point;
      this.updateColor();
    }
    onHueChange(hue) {
      this.hue = hue;
      this.updateColor();
    }
    onOpacityChange(opacity) {
      this.opacity = tuiRound(opacity, 2);
      this.updateColor();
    }
    getCurrentColor(hue, point) {
      return tuiHsvToRgb(hue * 360, point[0], (1 - point[1]) * 255);
    }
    updateColor() {
      this.colorChange.emit([...this.currentColor, this.opacity]);
    }
    static {
      this.ɵfac = function TuiColorPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorPickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiColorPickerComponent,
        selectors: [["tui-color-picker"]],
        inputs: {
          color: "color"
        },
        outputs: {
          colorChange: "colorChange"
        },
        standalone: false,
        decls: 5,
        vars: 7,
        consts: [[1, "t-flat", 3, "valueChange", "value"], [1, "t-wrapper", "t-wrapper_hue"], [1, "t-hue", 3, "valueChange", "value"], [1, "t-wrapper", "t-wrapper_opacity"], [1, "t-opacity", 3, "valueChange", "value"]],
        template: function TuiColorPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "tui-flat-picker", 0);
            i0.ɵɵlistener("valueChange", function TuiColorPickerComponent_Template_tui_flat_picker_valueChange_0_listener($event) {
              return ctx.onPointChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 1)(2, "tui-linear-picker", 2);
            i0.ɵɵlistener("valueChange", function TuiColorPickerComponent_Template_tui_linear_picker_valueChange_2_listener($event) {
              return ctx.onHueChange($event);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(3, "div", 3)(4, "tui-linear-picker", 4);
            i0.ɵɵlistener("valueChange", function TuiColorPickerComponent_Template_tui_linear_picker_valueChange_4_listener($event) {
              return ctx.onOpacityChange($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleProp("background-color", ctx.base);
            i0.ɵɵproperty("value", ctx.point);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("value", ctx.hue);
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("background", ctx.gradient);
            i0.ɵɵadvance();
            i0.ɵɵproperty("value", ctx.opacity);
          }
        },
        dependencies: [TuiFlatPickerComponent, TuiLinearPickerComponent],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;isolation:isolate}.t-flat[_ngcontent-%COMP%]{block-size:14rem;background:linear-gradient(#0000,#000),linear-gradient(to right,#fff,#fff0);margin-bottom:.25rem;overflow:hidden}.t-wrapper[_ngcontent-%COMP%]{position:relative;margin:1rem 1.25rem;border-radius:.5rem}.t-wrapper[_ngcontent-%COMP%]:after{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";box-shadow:inset 0 0 0 1px #00000014;pointer-events:none;border-radius:inherit}.t-wrapper_hue[_ngcontent-%COMP%]{background:red}.t-wrapper_opacity[_ngcontent-%COMP%]:before{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";z-index:-1;background-image:linear-gradient(45deg,var(--tui-base-03) 25%,transparent 25%,transparent 75%,var(--tui-base-03) 75%,var(--tui-base-03)),linear-gradient(45deg,var(--tui-base-03) 25%,transparent 25%,transparent 75%,var(--tui-base-03) 75%,var(--tui-base-03));background-size:.375rem .375rem;background-position:0 0,.1875rem .1875rem;border-radius:inherit}.t-hue[_ngcontent-%COMP%]{background:linear-gradient(to right,red,#ff0,#0f0,#0ff,#00f,#f0f,red);border-radius:inherit;margin:0 .5rem}.t-opacity[_ngcontent-%COMP%]{border-radius:inherit;margin:0 .5rem}"],
        changeDetection: 0
      });
    }
  }
  __decorate([tuiPure], TuiColorPickerComponent.prototype, "getCurrentColor", null);
  return TuiColorPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiFlatPickerModule = /*#__PURE__*/(() => {
  class TuiFlatPickerModule {
    static {
      this.ɵfac = function TuiFlatPickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiFlatPickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiFlatPickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return TuiFlatPickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiLinearPickerModule = /*#__PURE__*/(() => {
  class TuiLinearPickerModule {
    static {
      this.ɵfac = function TuiLinearPickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiLinearPickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiLinearPickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return TuiLinearPickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiColorPickerModule = /*#__PURE__*/(() => {
  class TuiColorPickerModule {
    static {
      this.ɵfac = function TuiColorPickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorPickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiColorPickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TuiFlatPickerModule, TuiLinearPickerModule]
      });
    }
  }
  return TuiColorPickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TUI_COLOR_SELECTOR_MODE_NAMES = tuiCreateToken(['Solid color', 'Gradient']);
const TUI_DEFAULT_INPUT_COLORS = new Map([['color-black-100', '#909090'], ['color-black-200', '#666666'], ['color-black-300', '#333333'], ['color-blue-100', '#1771e6'], ['color-blue-200', '#1464cc'], ['color-blue-300', '#0953b3'], ['color-gray-100', '#f5f5f6'], ['color-gray-200', '#e7e8ea'], ['color-gray-300', '#cbcfd3'], ['color-gray-400', '#959ba4'], ['color-gray-500', '#79818c'], ['color-gray-600', '#616871'], ['color-green-100', '#39b54a'], ['color-green-200', '#2ca53a'], ['color-green-300', '#168a21'], ['color-light-blue-100', '#ecf1f7'], ['color-light-blue-200', '#e4ebf3'], ['color-light-blue-300', '#dde4ed'], ['color-red-100', '#e01f19'], ['color-red-200', '#d3120e'], ['color-red-300', '#c40b08'], ['color-yellow-100', '#FFDD2C'], ['color-yellow-200', '#FCC521'], ['color-yellow-300', '#FAB618'], ['transparent', 'transparent']]);
const TuiColorSelectorMode = {
  SolidColor: 0,
  Gradient: 1
};
const TUI_COLOR_SELECTOR_DEFAULT_OPTIONS = {
  selectorMode: true,
  mode: TuiColorSelectorMode.SolidColor,
  color: [0, 0, 0, 1],
  colors: new Map(),
  gradient: {
    icons: {
      'to top right': '@tui.move-up-right',
      'to right': '@tui.move-right',
      'to bottom right': '@tui.move-down-right',
      'to bottom': '@tui.move-down',
      'to bottom left': '@tui.move-down-left',
      'to left': '@tui.move-left',
      'to top left': '@tui.move-up-left',
      'to top': '@tui.move-up'
    },
    steps: [[0, [0, 0, 0, 1]], [1, [255, 255, 255, 1]]],
    stop: 0,
    direction: 'to bottom',
    emptyStop: [0, 0, 0, 0],
    buttons: ['to top right', 'to right', 'to bottom right', 'to bottom', 'to bottom left', 'to left', 'to top left', 'to top']
  }
};
const TUI_COLOR_SELECTOR_OPTIONS = tuiCreateToken(TUI_COLOR_SELECTOR_DEFAULT_OPTIONS);
function tuiColorSelectorOptionsProvider(options) {
  return tuiProvideOptions(TUI_COLOR_SELECTOR_OPTIONS, options, TUI_COLOR_SELECTOR_DEFAULT_OPTIONS);
}
let TuiLinearMultiPickerComponent = /*#__PURE__*/(() => {
  class TuiLinearMultiPickerComponent {
    constructor() {
      this.$ = inject(TuiPickerService).pipe(takeUntilDestroyed()).subscribe(([x]) => this.onPicker(x));
      this.value = [0, 1];
      this.valueChange = new EventEmitter();
      this.indexChange = new EventEmitter();
      this.index = NaN;
    }
    onMouseUp() {
      this.index = NaN;
    }
    onMouseDown(index) {
      this.updateIndex(index);
    }
    onClick(index) {
      if (this.value.length > 2) {
        this.updateValue(this.value.filter((_, i) => i !== index));
      }
    }
    onPicker(x) {
      if (Number.isNaN(this.index)) {
        this.updateIndex(this.value.length);
        this.value = [...this.value, 0];
      }
      if (this.value.some((item, index) => item === x && index !== this.index)) {
        return;
      }
      this.updateValue(this.value.map((item, index) => index === this.index ? x : item));
    }
    updateIndex(index) {
      this.index = index;
      this.indexChange.emit(index);
    }
    updateValue(value) {
      this.value = value;
      this.valueChange.emit(value);
    }
    static {
      this.ɵfac = function TuiLinearMultiPickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiLinearMultiPickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiLinearMultiPickerComponent,
        selectors: [["tui-linear-multi-picker"]],
        hostBindings: function TuiLinearMultiPickerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("mouseup", function TuiLinearMultiPickerComponent_mouseup_HostBindingHandler() {
              return ctx.onMouseUp();
            }, false, i0.ɵɵresolveDocument);
          }
        },
        inputs: {
          value: "value"
        },
        outputs: {
          valueChange: "valueChange",
          indexChange: "indexChange"
        },
        standalone: false,
        features: [i0.ɵɵProvidersFeature([TuiPickerService])],
        decls: 1,
        vars: 1,
        consts: [["class", "t-circle", 3, "left", "dblclick", "mousedown", 4, "ngFor", "ngForOf"], [1, "t-circle", 3, "dblclick", "mousedown"]],
        template: function TuiLinearMultiPickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiLinearMultiPickerComponent_div_0_Template, 1, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.value);
          }
        },
        dependencies: [i1.NgForOf],
        styles: [_c1],
        changeDetection: 0
      });
    }
  }
  return TuiLinearMultiPickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPaletteComponent = /*#__PURE__*/(() => {
  class TuiPaletteComponent {
    constructor() {
      this.colors = new Map();
      this.selectedColor = new EventEmitter();
      this.originalOrder = (_a, _b) => 0;
    }
    static {
      this.ɵfac = function TuiPaletteComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPaletteComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiPaletteComponent,
        selectors: [["tui-palette"]],
        inputs: {
          colors: "colors"
        },
        outputs: {
          selectedColor: "selectedColor"
        },
        standalone: false,
        decls: 2,
        vars: 4,
        consts: [["type", "button", "class", "t-button", 3, "id", "background", "tuiHint", "tuiHintDescribe", "click", 4, "ngFor", "ngForOf"], ["type", "button", 1, "t-button", 3, "click", "id", "tuiHint", "tuiHintDescribe"]],
        template: function TuiPaletteComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiPaletteComponent_button_0_Template, 1, 5, "button", 0);
            i0.ɵɵpipe(1, "keyvalue");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(1, 1, ctx.colors, ctx.originalOrder));
          }
        },
        dependencies: [i1.NgForOf, i1$2.TuiHintDirective, i1$2.TuiHintDescribe, i1.KeyValuePipe],
        styles: ["[_nghost-%COMP%]{display:flex;flex-wrap:wrap;padding:.875rem}.t-button[_ngcontent-%COMP%]{-webkit-appearance:none;appearance:none;padding:0;background:none;font-size:inherit;line-height:inherit;inline-size:1.5625rem;block-size:1.5625rem;box-sizing:border-box;margin:.375rem;border-radius:var(--tui-radius-m);border:1px solid rgba(0,0,0,.08)}"],
        changeDetection: 0
      });
    }
  }
  return TuiPaletteComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiColorSelectorComponent = /*#__PURE__*/(() => {
  class TuiColorSelectorComponent {
    constructor() {
      this.selectorOptions = inject(TUI_COLOR_SELECTOR_OPTIONS);
      this.stops = new Map(this.selectorOptions.gradient.steps);
      this.currentStop = this.selectorOptions.gradient.stop;
      this.direction = this.selectorOptions.gradient.direction;
      this.sanitizer = inject(DomSanitizer);
      this.open = false;
      this.colors = this.selectorOptions.colors;
      this.colorChange = new EventEmitter();
      this.color = this.selectorOptions.color;
      this.modes = inject(TUI_COLOR_SELECTOR_MODE_NAMES);
      this.currentMode = this.modes[this.selectorOptions.mode];
      this.buttons = this.selectorOptions.gradient.buttons;
    }
    set colorSetter(color) {
      if (color.startsWith('linear-gradient')) {
        this.parseGradient(color);
      } else {
        this.parseColor(color);
      }
    }
    get selectorMode() {
      return this.selectorOptions.selectorMode;
    }
    get palette() {
      return this.filterPalette(this.colors, this.isGradient);
    }
    get stopsKeys() {
      return this.getStopsKeys(this.stops);
    }
    get currentColor() {
      return this.isGradient ? this.getStop(this.currentStop) : this.color;
    }
    get gradient() {
      return this.sanitizer.bypassSecurityTrustStyle(this.getGradient('to right'));
    }
    get isGradient() {
      return this.currentMode === this.modes[TuiColorSelectorMode.Gradient];
    }
    getIcon(direction) {
      return this.selectorOptions.gradient.icons[direction];
    }
    isModeActive(mode) {
      return this.currentMode === mode;
    }
    isDirectionActive(direction) {
      return this.direction === direction;
    }
    onPalettePick(color) {
      this.updateColor(color);
    }
    onDirectionChange(direction) {
      this.direction = direction;
      this.updateColor(this.getGradient(direction));
    }
    onModeSelect(mode) {
      this.currentMode = mode;
      this.open = false;
      this.updateColor(mode === this.modes[TuiColorSelectorMode.SolidColor] ? `rgba(${this.color.join(', ')})` : this.getGradient(this.direction));
    }
    onIndexChange(index) {
      this.currentStop = this.stopsKeys[index] ?? 0;
    }
    onColorChange(color) {
      if (!this.isGradient) {
        this.updateColor(`rgba(${color.join(', ')})`);
        return;
      }
      this.stops.set(this.currentStop, color);
      this.updateColor(this.getGradient(this.direction));
    }
    onStopsChange(stopsKeys) {
      const removed = this.stopsKeys.find(item => !stopsKeys.includes(item));
      const added = stopsKeys.find(item => !this.stopsKeys.includes(item));
      if (removed === undefined && added !== undefined) {
        this.addStop(added);
      }
      if (removed !== undefined && added === undefined) {
        this.removeStop(removed);
      }
      if (removed !== undefined && added !== undefined) {
        this.replaceStop(removed, added);
      }
      this.updateColor(this.getGradient(this.direction));
    }
    getStopsKeys(stops) {
      return Array.from(stops.keys());
    }
    filterPalette(colors, isGradient) {
      const map = new Map(colors);
      map.forEach((value, key) => {
        if (value.startsWith('linear-gradient') && !isGradient || !value.startsWith('linear-gradient') && isGradient) {
          map.delete(key);
        }
      });
      return map;
    }
    updateColor(color) {
      this.colorChange.emit(color);
    }
    getGradient(direction) {
      return `linear-gradient(${direction}, ${[...this.stopsKeys].sort(tuiDefaultSort).map(key => `rgba(${this.getStop(key).join(', ')}) ${key * 100}%`).join(', ')})`;
    }
    getStop(stop) {
      return this.stops.get(stop) || this.selectorOptions.gradient.emptyStop;
    }
    addStop(stop) {
      const closest = this.stopsKeys.reduce((prev, curr) => Math.abs(curr - stop) < Math.abs(prev - stop) ? curr : prev, this.stopsKeys[0] ?? 0);
      this.stops.set(stop, this.getStop(closest));
      this.stops = new Map(this.stops);
      this.currentStop = stop;
    }
    removeStop(stop) {
      this.stops.delete(stop);
      this.stops = new Map(this.stops);
      this.currentStop = this.stopsKeys[0] ?? 0;
    }
    replaceStop(removed, added) {
      const value = this.getStop(removed);
      this.currentStop = added;
      this.stops = new Map(this.stopsKeys.map(key => key === removed ? [added, value] : [key, this.getStop(key)]));
    }
    parseGradient(color) {
      if (color === this.getGradient(this.direction)) {
        return;
      }
      const gradient = tuiParseGradient(tuiGetGradientData(color));
      this.direction = gradient.side;
      this.currentStop = this.selectorOptions.gradient.stop;
      this.stops = new Map(gradient.stops.length ? gradient.stops.map(({
        color,
        position
      }) => [parseFloat(position) / 100, tuiParseColor(color)]) : this.selectorOptions.gradient.steps);
    }
    parseColor(color) {
      this.currentStop = this.selectorOptions.gradient.stop;
      this.color = tuiParseColor(color);
    }
    static {
      this.ɵfac = function TuiColorSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorSelectorComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiColorSelectorComponent,
        selectors: [["tui-color-selector"]],
        inputs: {
          colors: "colors",
          colorSetter: [0, "color", "colorSetter"]
        },
        outputs: {
          colorChange: "colorChange"
        },
        standalone: false,
        decls: 5,
        vars: 5,
        consts: [["menu", ""], [4, "ngIf"], [3, "colorChange", "color"], ["tuiGroup", "", "class", "t-edit", 3, "color", "colorChange", 4, "ngIf"], ["class", "t-palette", 3, "colors", "selectedColor", 4, "ngIf"], [1, "t-select", 3, "tuiDropdownOpenChange", "tuiDropdown", "tuiDropdownOpen"], ["appearance", "", "size", "s", "tuiButton", "", "tuiChevron", "", "type", "button"], [1, "t-hr"], ["role", "menu", "size", "s", 1, "t-menu"], ["role", "menuitemradio", "tuiOption", "", "type", "button", 3, "click", "keydown.enter.prevent", "keydown.space.prevent", 4, "ngFor", "ngForOf"], ["role", "menuitemradio", "tuiOption", "", "type", "button", 3, "click", "keydown.enter.prevent", "keydown.space.prevent"], ["icon", "@tui.check", "class", "t-checkmark", 4, "ngIf"], ["icon", "@tui.check", 1, "t-checkmark"], [1, "t-wrapper"], [1, "t-gradient", 3, "indexChange", "valueChange", "value"], [1, "t-buttons"], ["appearance", "", "size", "xs", "tuiHintDescribe", "", "tuiIconButton", "", "type", "button", "class", "t-direction", 3, "t-direction_active", "iconStart", "tuiHint", "click", 4, "ngFor", "ngForOf"], ["appearance", "", "size", "xs", "tuiHintDescribe", "", "tuiIconButton", "", "type", "button", 1, "t-direction", 3, "click", "iconStart", "tuiHint"], ["tuiGroup", "", 1, "t-edit", 3, "colorChange", "color"], [1, "t-palette", 3, "selectedColor", "colors"]],
        template: function TuiColorSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, TuiColorSelectorComponent_ng_container_0_Template, 7, 3, "ng-container", 1)(1, TuiColorSelectorComponent_ng_container_1_Template, 5, 4, "ng-container", 1);
            i0.ɵɵelementStart(2, "tui-color-picker", 2);
            i0.ɵɵlistener("colorChange", function TuiColorSelectorComponent_Template_tui_color_picker_colorChange_2_listener($event) {
              return ctx.onColorChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, TuiColorSelectorComponent_tui_color_edit_3_Template, 1, 1, "tui-color-edit", 3)(4, TuiColorSelectorComponent_tui_palette_4_Template, 1, 1, "tui-palette", 4);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.selectorMode);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isGradient);
            i0.ɵɵadvance();
            i0.ɵɵproperty("color", ctx.currentColor);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isGradient);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.palette.size);
          }
        },
        dependencies: [i1.NgForOf, i1.NgIf, i2$2.TuiButton, TuiColorPickerComponent, TuiLinearMultiPickerComponent, TuiColorEditComponent, i1$1.TuiDropdownDirective, i1$1.TuiDropdownOpen, i2$1.TuiDataListComponent, i2$1.TuiOption, i8.TuiGroup, TuiPaletteComponent, i1$2.TuiHintDirective, i1$2.TuiHintDescribe, i11.TuiChevron, i12.TuiIcon],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;isolation:isolate;inline-size:22.6rem}[_nghost-%COMP%]   *:disabled[_nghost-%COMP%], *:disabled   [_nghost-%COMP%]{pointer-events:none}.t-wrapper[_ngcontent-%COMP%]{position:relative;margin:1.25rem;border-radius:.5rem}.t-wrapper[_ngcontent-%COMP%]:after{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";box-shadow:inset 0 0 0 1px #00000014;pointer-events:none;border-radius:inherit}.t-wrapper[_ngcontent-%COMP%]:before{position:absolute;top:0;left:0;inline-size:100%;block-size:100%;content:\"\";z-index:-1;background-image:linear-gradient(45deg,var(--tui-base-03) 25%,transparent 25%,transparent 75%,var(--tui-base-03) 75%,var(--tui-base-03)),linear-gradient(45deg,var(--tui-base-03) 25%,transparent 25%,transparent 75%,var(--tui-base-03) 75%,var(--tui-base-03));background-size:.375rem .375rem;background-position:0 0,.1875rem .1875rem;border-radius:inherit}.t-hr[_ngcontent-%COMP%]{block-size:1px;margin:0 0 0 -1px;border:none;background:var(--tui-base-03)}.t-gradient[_ngcontent-%COMP%]{margin:0 .5rem;border-radius:inherit}.t-select[_ngcontent-%COMP%]{margin:.75rem .5rem 0}.t-arrow[_ngcontent-%COMP%]{transition-property:transform;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out}.t-arrow_rotated[_ngcontent-%COMP%]{transform:rotate(180deg)}.t-menu[_ngcontent-%COMP%]{inline-size:11.25rem}.t-checkmark[_ngcontent-%COMP%]{margin-left:auto;inline-size:1rem;block-size:1rem}.t-buttons[_ngcontent-%COMP%]{display:flex;padding:0 .75rem 1.25rem;justify-content:space-between}.t-direction[_ngcontent-%COMP%]{color:var(--tui-text-02);margin:0 .375rem}.t-direction[_ngcontent-%COMP%]:hover, .t-direction_active[_ngcontent-%COMP%]{color:var(--tui-text-01);background:var(--tui-secondary-hover)}.t-edit[_ngcontent-%COMP%]{margin:1.25rem}.t-palette[_ngcontent-%COMP%]{box-sizing:border-box;box-shadow:inset 0 1px var(--tui-base-03)}"],
        changeDetection: 0
      });
    }
  }
  __decorate([tuiPure], TuiColorSelectorComponent.prototype, "getStopsKeys", null);
  __decorate([tuiPure], TuiColorSelectorComponent.prototype, "filterPalette", null);
  return TuiColorSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiLinearMultiPickerModule = /*#__PURE__*/(() => {
  class TuiLinearMultiPickerModule {
    static {
      this.ɵfac = function TuiLinearMultiPickerModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiLinearMultiPickerModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiLinearMultiPickerModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return TuiLinearMultiPickerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiPaletteModule = /*#__PURE__*/(() => {
  class TuiPaletteModule {
    static {
      this.ɵfac = function TuiPaletteModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiPaletteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiPaletteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, i1$2.TuiHintComponent]
      });
    }
  }
  return TuiPaletteModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiColorSelectorModule = /*#__PURE__*/(() => {
  class TuiColorSelectorModule {
    static {
      this.ɵfac = function TuiColorSelectorModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiColorSelectorModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TuiColorSelectorModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TuiSvgComponent, TuiColorPickerModule, TuiLinearMultiPickerModule, TuiColorEditModule, TuiPaletteModule, TuiIcon, i1$2.TuiHintComponent, i2$1.TuiDataListComponent, i2$1.TuiOption]
      });
    }
  }
  return TuiColorSelectorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_COLOR_SELECTOR_DEFAULT_OPTIONS, TUI_COLOR_SELECTOR_MODE_NAMES, TUI_COLOR_SELECTOR_OPTIONS, TUI_DEFAULT_INPUT_COLORS, TuiColorEditComponent, TuiColorEditModule, TuiColorPickerComponent, TuiColorPickerModule, TuiColorSelectorComponent, TuiColorSelectorMode, TuiColorSelectorModule, TuiFlatPickerComponent, TuiFlatPickerModule, TuiLinearMultiPickerComponent, TuiLinearMultiPickerModule, TuiLinearPickerComponent, TuiLinearPickerModule, TuiPaletteComponent, TuiPaletteModule, TuiPickerService, tuiColorSelectorOptionsProvider };
